<ng-template #decisionButton>
	<eif-custom-menu
		[text]="'file-integrations.Decision' | translate"
		[postIcon]="'fa-solid fa-caret-down'"
		[menuItems]="getDecisionMenuItems">
	</eif-custom-menu>
</ng-template>

<ng-template
	#fileIntegrationCard
	let-row>
	<div class="eif-card">
		<div class="eif-card-header">
			<div class="label">{{ row.FileType | translate: 'list-integrationFileType' }}</div>
			<div
				[eifTooltip]="row.FileName"
				class="truncate">
				@if (showIntegratinDetails(row)) {
					<a [routerLink]="getFileDetailLink(row)">
						{{ row.FileName }}
					</a>
				} @else {
					<div class="text-truncate">
						<span class="fw-bold">{{ row.FileName }}</span>
					</div>
				}
			</div>
		</div>
		<div class="eif-card-section">
			<div class="label">{{ 'file-integrations.fileType' | translate }}</div>
			<div
				[eifTooltip]="row.FileType"
				class="truncate">
				{{ row.FileType }}
			</div>
		</div>
		<div class="eif-card-section">
			<div class="label">{{ 'file-integrations.fileSubmitingCompany' | translate }}</div>
			<div
				[eifTooltip]="getFileSubmitingCompanyName(row).companyName"
				class="truncate">
				{{ getFileSubmitingCompanyName(row).companyName }}
			</div>
			<div>{{ getFileSubmitingCompanyName(row).completeVatNumber }}</div>
		</div>
		<div class="eif-card-section">
			<div class="label">{{ 'file-integrations.fileProcessedRecords' | translate }}</div>
			<div>
				<strong>{{ row.FileAmounts[0]?.IntegratedDocumentsCount || 0 }}</strong>
			</div>
		</div>
		@if (showIntegratedDocumentsAmount()) {
			<div class="eif-card-section">
				<div class="label">{{ 'file-integrations.fileDocumentsProcessedAmount' | translate }}</div>
				<div>
					<strong>{{ row.FileAmounts[0]?.IntegratedDocumentsAmount | currencyLocale: row.FileAmounts[0]?.Currency }}</strong>
				</div>
			</div>
		}
		<div class="eif-card-section">
			<div class="label">{{ 'file-integrations.processingDate' | translate }}</div>
			<div>{{ row.CreatedOn }}</div>
		</div>
		<div class="eif-card-section">
			<div class="label">{{ 'file-integrations.fileState' | translate }}</div>
			<div>
				<span class="tag {{ row.FileStatus }}">{{ row.FileStatus | translate: 'list-fileIntegrationState' }}</span>
			</div>
		</div>
	</div>
</ng-template>

<div class="container-fluid animated fadeIn">
	<div class="page-header-wrapper">
		<div class="page-header">
			<div class="page-header-left">
				<h2>
					{{ 'file-integrations.pageTitle' | translate }}
				</h2>
			</div>
			<div class="page-header-right">
				@if (showFileUploadButton()) {
					<eif-custom-button
						[text]="'file-integrations.FileUpload' | translate"
						[preIcon]="'fa-light fa-file-upload'"
						(action)="gotoFileUpload()">
					</eif-custom-button>
				}
			</div>
		</div>
	</div>

	<!-- CONTENT -->
	<div class="simple-card top-line ps-3 pe-3">
		<eif-custom-table
			#customTable
			[columns]="tableColumns"
			[rows]="fileIntegrations"
			[loading]="isTableLoading"
			[pagination]="tablePagination"
			[filters]="tableFilters"
			[enableFilters]="true"
			[idField]="'FileId'"
			[identifier]="'files-integration-search'"
			[pathPattern]="'/files-integration'"
			[selectActions]="selectActions"
			[userTimeZone]="loggedUser?.TimeZone || 'UTC'"
			(searchRequested)="onSearchRequested($event)"
			[selectionMode]="'multiple'"
			[persistSelection]="true"
			(selectionChange)="onSelectionChange($event)"
			[cardTemplate]="fileIntegrationCard"
			[export]="tableExport">
		</eif-custom-table>
	</div>
</div>
